import { createContext } from 'react';
import utils from '../../utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';

export type OpenDataRoomNodeMixpanelProps = {
  dataRoomName: string;
  ownerId: string;
  userSide: QAndASides;
  dealRoomId: string;
};

type DocumentViewContextValues = {
  activeNodeId?: string;
  openNode: (
    node: DataRoomNode,
    mixpanelProps?: OpenDataRoomNodeMixpanelProps,
    siblings?: DataRoomNode[],
  ) => void;
  openSingleNode: (
    node: DataRoomNode,
    mixpanelProps?: OpenDataRoomNodeMixpanelProps,
  ) => void;
  updateSiblings: (
    siblings: DataRoomNode[],
    hasMoreSiblings?: boolean,
    onLoadMoreSiblings?: () => void,
  ) => void;
};

export default createContext<DocumentViewContextValues>({
  activeNodeId: '',
  openNode: utils.noop,
  openSingleNode: utils.noop,
  updateSiblings: utils.noop,
});
